import React from 'react';
import { Dialog } from 'primereact/dialog';

interface PDFViewerWithPluginProps {
    fileUrl: string;
    isEng: boolean;
    visible: boolean;
    onClose: () => void;
}

const PDFViewerPrintComponent: React.FC<PDFViewerWithPluginProps> = ({ fileUrl, isEng, visible, onClose }) => {
    return (
        <Dialog
            header={isEng ? "PDF Print" : "Impression PDF"}
            style={{ width: "60vw" }}
            onHide={onClose}
            visible={visible}
            modal
        >
            <div style={{ height: '70vh', marginBottom: '20px' }}>
                <iframe
                    src={fileUrl}
                    title={isEng ? "PDF Print Preview" : "Aperçu d'impression PDF"}
                    style={{ width: '100%', height: '100%', border: 'none' }}
                />
            </div>
            <div style={{ textAlign: 'right', marginTop: 16 }}>
                <button className="ontario-button ontario-button--secondary" onClick={onClose}>
                    {isEng ? "Close" : "Fermer"}
                </button>
            </div>
        </Dialog>
    );
};

export default PDFViewerPrintComponent;
